import { render, staticRenderFns } from "./IbMaskedInput.vue?vue&type=template&id=f15c3aa2&scoped=true"
import script from "./IbMaskedInput.vue?vue&type=script&lang=js"
export * from "./IbMaskedInput.vue?vue&type=script&lang=js"
import style0 from "./IbMaskedInput.vue?vue&type=style&index=0&id=f15c3aa2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15c3aa2",
  null
  
)

export default component.exports